// extracted by mini-css-extract-plugin
module.exports = {"subSectionTitle":"Feedback_subSectionTitle__1usEK","itemList":"Feedback_itemList__2A2oR"};